// testing mock data
import { ANDROID } from '../constants';

export const testState = {
  isLoading: false,
  0: {
    default: '<html lang="en"><p>preview</p></html>',
  },
  1: {
    activePushDeviceWrapper: ANDROID,
    default: '<html lang="en"><p>in-app preview with inbox</p></html>',
    inAppDisplaySettings: {
      top: {
        percentage: 0,
      },
      bottom: {
        percentage: 0,
      },
      bgColor: {
        alpha: 0.32,
        hex: '#33aaaa',
      },
    },
    inboxMetadata: {
      title: 'inbox title',
      subtitle: 'inbox subtitle',
    },
  },
  2: {
    default: '<html lang="en"><p>in-app preview without inbox</p></html>',
    inAppDisplaySettings: {
      top: {
        percentage: 0,
      },
      bottom: {
        percentage: 0,
      },
      bgColor: {
        alpha: 1,
        hex: '#33aaaa',
      },
    },
  },
};

export const previewTemplateResponseProps = { data: { globals: { __templateId__: 1 } } };

export const getInAppContentResponseProps = {
  data: { content: { inAppDisplaySettings: {}, inboxMetadata: {} } },
};
